import { render, staticRenderFns } from "./YoutubeAssets.vue?vue&type=template&id=0067aaa0"
import script from "./YoutubeAssets.vue?vue&type=script&lang=js"
export * from "./YoutubeAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports